import type { ReactNode } from 'react'
import { KILO, type BentoGradient } from '../../constants/KILO_THEME'

const GRADIENT_CLASS: Record<BentoGradient, string> = {
  forest: KILO.gradient.forest,
  copper: KILO.gradient.copper,
  slate: KILO.gradient.slate,
  none: KILO.bg.card,
}

type BentoCardProps = {
  children: ReactNode
  gradient?: BentoGradient
  className?: string
  featured?: boolean
}

const BentoCard = ({ children, gradient = 'none', className = '', featured = false }: BentoCardProps) => (
  <article
    className={`${GRADIENT_CLASS[gradient]} ${KILO.border.default} ${KILO.radius.card} p-5 ${
      featured
        ? 'shadow-kilo-raised ring-1 ring-kilo-accent/20'
        : 'shadow-kilo-card'
    } ${className}`}
  >
    {children}
  </article>
)

export default BentoCard
